import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ShareContext } from "components/context/share/ShareContext";
import ContentPageShareLink from "./ContentPageShareLink";

export const ContentPageShareAdditionalLinksMobile = (props) => {
	const data = useContext(ShareContext);
	const [firstInitalLoad, setFirstInitialLoad] = useState(true);
	const { publicLinks, additionalLinks, copyLabel, copyConfirm, analytics } = data;
	const { onClick, additionalMobileFlag } = props;
	const { label, links } = additionalLinks;
	useEffect(() => {
		if (firstInitalLoad && additionalMobileFlag) {
			setFirstInitialLoad(false);
		}
	}, [additionalMobileFlag, firstInitalLoad, setFirstInitialLoad]);

	return (
		<div
			className={
				`content-page-share-additional-links-mobile ${
					additionalMobileFlag ? "share-additional-mobile-animation" : ""
				}` +
				(!publicLinks ? " content-page-share-additional-links-mobile-visible" : "") +
				(firstInitalLoad && publicLinks
					? " content-page-share-additional-links-mobile-invisible"
					: "")
			}
		>
			{publicLinks && (
				<button
					className="content-page-share-additional-links-mobile-back"
					aria-label="go back"
					onClick={onClick}
				>
					{label}
				</button>
			)}
			{links.map((link, index) => {
				return (
					<ContentPageShareLink
						className="content-page-share-additional-links-mobile-url"
						shareLabel={link.shareLabel}
						shareUrl={link.shareUrl}
						copyLabel={copyLabel}
						key={index}
						copyConfirm={copyConfirm}
						analytics={analytics}
					/>
				);
			})}
		</div>
	);
};

ContentPageShareAdditionalLinksMobile.propTypes = {
	onClick: PropTypes.func,
	additionalMobileFlag: PropTypes.bool
};

export default {
	ContentPageShareAdditionalLinksMobile
};
